import { HttpResponse } from '@angular/common/http'
import { Component } from '@angular/core'
import { Router } from '@angular/router'
import { EventType } from '@app/core/model/enums/event-type.enum'
import { ScenarioService } from '@app/features/company-management/service/scenario.service'
import { ScopeOverviewService } from '@app/features/scope-overview/service/scope-overview.service'
import { UserNotification } from '@core/model/user-notification.model'
import { CoreState } from '@core/store'
import { AuthSelectors } from '@core/store/selectors/auth.selector'
import { Store } from '@ngrx/store'

@Component({ selector: 'notification-status', templateUrl: './notification-status.component.html' })
export class NotificationStatusComponent {
  constructor(
    private store: Store<CoreState>,
    private scopeOverviewService: ScopeOverviewService,
    private scenarioService: ScenarioService,
    private router: Router
  ) {}

  unreadyNotificationsCount!: number
  notificationStatus: NotificationStatus = new NotificationStatus()

  unreadyNotificationsCount$ = this.store.select(AuthSelectors.selectUnreadUserNotifications)

  onNotificationClick(notif: UserNotification) {
    this.notificationStatus.showNotifications = false
    if (notif.entitySourceType === EntitySourceType.SCOPE) {
      this.router.routeReuseStrategy.shouldReuseRoute = function () {
        return false
      }
      this.router.navigateByUrl('scopes/scope-overview/' + notif.entity.id)
    } else if (notif.entitySourceType === EntitySourceType.SCOPE_OF_WORK) {
      this.router.routeReuseStrategy.shouldReuseRoute = function () {
        return false
      }
      this.router.navigateByUrl('scopes/folder-overview/' + notif.entity.id)
    } else if (notif.entitySourceType === EntitySourceType.EXTERNAL_FILE) {
      if (notif.eventType === EventType.FILE_IMPORT_FAILED) {
        if (notif.properties && notif.properties.importUuid)
          this.scenarioService.getImportValidationFile(notif.properties.importUuid).subscribe((resp) => {
            this.downloadFile(resp)
          })
      } else if (notif.properties && notif.properties.uuid) {
        this.scopeOverviewService.downloadDataExport(notif.properties.uuid, null).subscribe((resp) => {
          this.downloadFile(resp)
        })
      }
    }
  }

  downloadFile(res: HttpResponse<Blob>) {
    if (res.body != null) {
      const a = document.createElement('a')
      const fileName = res.headers.get('content-disposition')
      a.href = URL.createObjectURL(res.body)
      if (fileName != null) {
        a.download = fileName.split('filename=')[1].split(';')[0]
      }
      a.click()
    }
  }

  onCloseNotifications() {
    this.notificationStatus.showNotifications = false
  }

  onMarkAllAsRead() {
    this.notificationStatus.showNotifications = false
  }
}

class NotificationStatus {
  showNotifications = false
}

export enum EntitySourceType {
  SCOPE = 'SCOPE',
  SCOPE_OF_WORK = 'SCOPE_OF_WORK',
  EXTERNAL_FILE = 'EXTERNAL_FILE',
}
